import { $http } from "@/utils/http";

import {
    SET_PROMOTIONS_LIST,
    SET_LOADING_PROMOTIONS_LIST,
    CHANGE_PROMOTIONS_SKIP,
    SET_LOADING_CURRENT_LIST,
    SET_PROMOTIONS_CURRENT_LIST,
    RESET_SKIP,
    PROMOTIONS_PRODUCT_LOADING,
    PROMOTIONS_PRODUCT_LENGTH,
    RESET_LIMIT,
    SET_SOME_LOADING,
    PROMOTIONS_CARDS_LENGTH,
    RESET_LIST,
} from "../mutation-types";

import { GET_PROMOTIONS_LIST, GET_PROMOTIONS_CURRENT_LIST } from "../action-types";

const state = {
    someLoading: false,
    list: null,
    currentPromotions: null,
    skip: 0,
    limit: 2,
    listLoading: false,
    currentListLoading: false,
    productLoading: false,
    productsLength: 0,
    test: 0,
    cardsLength: 0,
};

const getters = {
    skip: state => state.skip,
    getCardsLength: state => state.cardsLength,
    getProductsLength: state => state.productsLength,
    getList: state => state.list,
    getCurrentList: state => state.currentPromotions,
    getSkip: state => state.skip,
    productLoading: state => state.productLoading,
    getLimit: state => state.limit,
    someLoading: state => state.someLoading,
    resetList: state => state.resetLimit,
};
const actions = {
    [GET_PROMOTIONS_LIST]: async ({ commit }) => {
        commit(PROMOTIONS_PRODUCT_LOADING, true);
        try {
            const response = await $http.get(`v1/promotions?skip=${state.skip}&take=${state.limit}&include=products`);
            commit(CHANGE_PROMOTIONS_SKIP);
            commit(RESET_LIST);
            commit(SET_PROMOTIONS_LIST, response.data.data);
            commit(PROMOTIONS_PRODUCT_LENGTH, response.data.data.length);
        } catch (e) {
            throw e;
        } finally {
            commit(PROMOTIONS_PRODUCT_LOADING, false);
        }
    },
    [GET_PROMOTIONS_CURRENT_LIST]: async ({ commit }, payload) => {
        commit(SET_SOME_LOADING, true);
        commit(PROMOTIONS_PRODUCT_LOADING, true);
        try {
            const response = await $http.get(`/v1/promotions/${payload.promotion_slug}/products/${payload.slug}/same `);
            commit(CHANGE_PROMOTIONS_SKIP);
            commit(SET_PROMOTIONS_CURRENT_LIST, response.data.data);
            commit(PROMOTIONS_CARDS_LENGTH, response.data.data.length);
        } catch (e) {
            throw e;
        } finally {
            commit(SET_SOME_LOADING, false);
            commit(PROMOTIONS_PRODUCT_LOADING, false);
        }
    },
};
const mutations = {
    [CHANGE_PROMOTIONS_SKIP](state) {
        state.skip += state.limit;
        // state.skip++
    },
    [PROMOTIONS_PRODUCT_LENGTH](state, data) {
        state.productsLength = data;
    },
    [PROMOTIONS_CARDS_LENGTH](state, data) {
        state.cardsLength = data;
    },
    [RESET_SKIP](state) {
        state.skip = 0;
    },
    [RESET_LIMIT](state) {
        state.limit = 8;
    },
    [SET_LOADING_PROMOTIONS_LIST](state, status) {
        state.listLoading = status;
    },
    [SET_PROMOTIONS_LIST](state, list) {
        state.list = list;
    },
    [SET_PROMOTIONS_CURRENT_LIST](state, data) {
        state.currentPromotions = data;
    },
    [SET_LOADING_CURRENT_LIST](state, status) {
        state.currentListLoading = status;
    },
    ////
    [PROMOTIONS_PRODUCT_LOADING](state, status) {
        state.productLoading = status;
    },
    [SET_SOME_LOADING](state, status) {
        state.someLoading = status;
    },
    [RESET_LIST](state) {
        state.list = 0;
    },
};
export default {
    state,
    getters,
    actions,
    mutations,
};
